import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import esLocale from '@fullcalendar/core/locales/es'
import { ModalModule } from '../Modal'
import './Calendar.css'

const Calendar = ({useFetchInit}) => {

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        //------------- Formularios
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ FetchData
    const { fetchAllEvents } = FetchData
    const { events } = fetchAllEvents

    //------------------------------------------------- GlobalStates
    const { calendarRef } = globalStates

    //------------------------------------------------- Actions
    const {handleCustomButtonClick, handleClickShowModal} =  Actions

    return (
        <div className="content">
            <FullCalendar
                plugins={[ dayGridPlugin, timeGridPlugin]} //Extraer las vistas de mes, semana, día y lista
                selectable={true} //Permite seleccionar un evento
                displayEventTime={false} //Se muestra el tiempo del evento
                initialView="dayGridMonth" //Vista de mes predeterminada al entrar al calendiario
                timeZone="GTM-6" //Zona horaria
                locale={esLocale} //Es una función descargada de fullcalendar para mostrar información en español
                //Se muestran los eventos extraídos de la bd
                events={events}
                //Personalización del tamaño del texto
                eventContent={(arg) => {
                    return <span style={{fontSize: '0.6vw'}}>{arg.event.title}</span> 
                }}
                //Personalización de botones
                customButtons={
                    {
                        customButtonPrev: {
                            icon: "chevron-left",
                            click: function() {
                                // Movilización previa de fecha
                                calendarRef.current.getApi().prev()

                                //FUNCIÓN PARA EXTRAER MES Y ASÍ EXTRAER LA DATA PARA RESPECTIVO MES
                                handleCustomButtonClick()
                            }
                        },
                        customButtonNext: {
                            icon: "chevron-right",
                            click: function() {
                                // Movilización posterior de fecha
                                calendarRef.current.getApi().next();

                                //FUNCIÓN PARA EXTRAER MES Y ASÍ EXTRAER LA DATA PARA RESPECTIVO MES
                                handleCustomButtonClick()
                            }
                        },
                        customButtonToday: {
                            text: "Hoy",
                            click: function() {
                                // Movilización de fecha a Hoy
                                calendarRef.current.getApi().today();

                                //FUNCIÓN PARA EXTRAER MES Y ASÍ EXTRAER LA DATA PARA RESPECTIVO MES
                                handleCustomButtonClick()
                            }
                        }
                    }
                }
                //Header  del calendario, se agregan los botones personalizados y las vistas disponibles
                headerToolbar={{
                    left: "customButtonPrev,customButtonNext customButtonToday",
                    center: "title",
                    right: "dayGridMonth,timeGridDay"
                }}
                height={730} //Tamaño específico del calendario a lo largo
                aspectRatio={2.5} //Función para ajustar el calendario en las pantallas
                eventClick={(info) => handleClickShowModal( info.event )} // Evento Clic para mostar modal
                ref={calendarRef} //Variable para referencia a este mismo calendario
                //Ajustes dependiendo de la vista
                views={{
                    timeGridDay: {
                        type: 'timeGridDay',
                        slotLabelFormat: () => '',
                        allDaySlot:true,
                        slotDuration: '24:00',
                        dayMaxEventRows: 20, //Limita eventos visibles en la franja "Todo" y agrega el enlace "+X más" (con scroll) para el resto
                    },
                    dayGridMonth: {
                        dayMaxEventRows: 15
                    }
                }}
            />
            <ModalModule useFetchInit={useFetchInit}/>
        </div>
    )
}

export {
    Calendar
}
